import { render } from "./commonInformationCard.vue?vue&type=template&id=2644ba71&scoped=true"
import script from "./commonInformationCard.vue?vue&type=script&lang=js"
export * from "./commonInformationCard.vue?vue&type=script&lang=js"

import "./commonInformationCard.vue?vue&type=style&index=0&id=2644ba71&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2644ba71"]])

export default __exports__